export function isClientPortalHost() {
  if (typeof window === "undefined") {
    return false;
  }

  return ["portal.arqum.com.br", "portal.localhost"].includes(window.location.hostname);
}
